import React from 'react';
import Authorization from '../components/common/Authorization';

/**
 * Shared auth page layout: branding panel + Clerk form area.
 * Layout: auth-layout.css (grid split + flex-centered panel).
 */
const AuthShell = ({ title, children }) => (
  <div className="auth-shell">
    <Authorization />
    <main className="auth-shell-panel" aria-label={title ? `${title} form` : 'Authentication'}>
      <div className="auth-shell-content">
        {title ? (
          <h1 className="auth-shell-title primary-heading">{title}</h1>
        ) : null}
        <div className="auth-shell-clerk">{children}</div>
      </div>
    </main>
  </div>
);

export default AuthShell;
